var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('brand-discount',{attrs:{"shop-data":_vm.discountsData,"img-height":"4.375rem"}})}
var staticRenderFns = []

export { render, staticRenderFns }